import { SxProps } from '@mui/material';

import { CustomTableVariant } from '@/components/table/CustomTable.comp.tsx';

export const CustomTableSelectMaxRowsStyles = (params: { size: CustomTableVariant }): SxProps => ({
  '& .MuiSelect-select': {
    alignItems: 'center',
    display: 'flex',
    py: params.size === 'small' ? 0 : 'inherit',
  },
  border: 'none',
  fontSize: '1rem',
});
